import { create } from "zustand";
import { LogicChain } from "../types/logicChain";

interface InsightState {
  isOpen: boolean;
  currentChain: LogicChain | null;
  activeMessageId: string | null;
  loading: boolean;
  togglePanel: () => void;
  openPanel: () => void;
  closePanel: () => void;
  setActiveMessageId: (messageId: string | null) => void;
  loadChain: (chain: LogicChain | null) => void;
  setLoading: (loading: boolean) => void;
}

export const useInsightStore = create<InsightState>((set) => ({
  isOpen: false,
  currentChain: null,
  activeMessageId: null,
  loading: false,

  togglePanel: () => set((state) => ({ isOpen: !state.isOpen })),
  openPanel: () => set({ isOpen: true }),
  closePanel: () => set({ isOpen: false }),
  setActiveMessageId: (messageId) => set({ activeMessageId: messageId }),
  loadChain: (chain) => set({ currentChain: chain, loading: false }),
  setLoading: (loading) => set({ loading }),
}));
